<template>
  <div id="wrap-projects">

    <loading :active.sync="busy"/>

    <!-- Empty container -->
    <div id="empty-container" v-if="!(projects.length-1)">
      <div id="empty-subtitle">{{ $t("lab.empty_subtitle") }}</div>
      <div id="empty-title">
        <div>{{ $t("lab.empty_title") }}</div>
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-icon small color="#536BFF">mdi-information</v-icon>
            </div>
          </template>
          <div>{{ $t("lab.project_info_1") }}</div>
          <div>{{ $t("lab.project_info_2") }}</div>
        </v-tooltip>
      </div>
      <v-btn id="empty-create-project" depressed dark color="primary"
        @click.stop="createProject()">
        <span>{{ $t("lab.start_project") }}</span>
      </v-btn>
    </div>

    <!-- Container -->
    <div id="header-projects" v-else>

      <div id="title-projects">
        {{ $t("header.my_projects") }}
      </div>

      <div id="btns-projects">

        <v-btn v-if="is_inactive"
          id="create-project" dark depressed color="primary"
          @click.stop="activate_dialog=true">
          <span>{{ $t("lab.activate_projects") }}</span>
          <span>({{ activated_projects.length }}/3)</span>
        </v-btn>

        <v-btn
          id="create-project" text color="primary"
          @click.stop="createProject()">
          <v-icon>mdi-plus</v-icon>
          <span>{{ $t("lab.start_project") }}</span>
        </v-btn>

        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-btn icon color="#c1c3c9">
                <v-icon>mdi-sort-descending</v-icon>
              </v-btn>
            </div>
          </template>
          <v-list dense>
            <v-list-item @click="sort_by=sort_by==2?1:2">
              <v-list-item-icon small>
                <v-icon v-if="sort_by==1" color="#766BFF">mdi-arrow-up</v-icon>
                <v-icon v-if="sort_by==2" color="#766BFF">mdi-arrow-down</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                {{ $t('sorting.title') }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="sort_by=0">
              <v-list-item-icon small>
                <v-icon v-if="sort_by==0" color="#766BFF">mdi-arrow-down</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                {{ $t('sorting.visited_date') }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="sort_by=sort_by==4?3:4">
              <v-list-item-icon small>
                <v-icon v-if="sort_by==3" color="#766BFF">mdi-arrow-up</v-icon>
                <v-icon v-if="sort_by==4" color="#766BFF">mdi-arrow-down</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                {{ $t('sorting.created_date') }}
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>

    <div id="container-projects" v-if="!!(projects.length-1)">

      <!-- Activated projects -->
      <div v-for="(i) in [1,3,4,2]" :key=i class="list-projects"
        v-if="!!sorted_projects.filter(v=>v.status==i).length">

        <div class="list-header">
          <div class="list-title">
            <span>{{ $t('lab.' + project_status[i].name + '_project') }}</span>
            <span>[{{ sorted_projects.filter(v=>v.status==i).length }}]</span>
          </div>
        </div>

        <div class="list-cards">
          <v-card class="card" flat
            v-for="(item, index) in sorted_projects"
            :key="`card-${index}-${item.list_mode}`"
            v-if="item.status==i"
            @click="getProject(item.proj_id)">

            <div class="card-header">
              <div class="card-title">
                <span v-if="item.mode==11"><v-icon>mdi-account-multiple</v-icon>&nbsp;</span>
                <span>{{ item.title }}</span>
              </div>
              <!-- <v-menu offset-y>
                <template v-slot:activator="{ on: { click } }">
                  <div v-on:click.stop.prevent="click">
                    <v-btn class="more" small icon color="#c1c3c9">
                      <v-icon small>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </div>
                </template>
                <v-list dense>
                  <v-list-item @click="updateProject(item.proj_id)">
                    <div>{{ $t("update_project.update_project") }}</div>
                  </v-list-item>
                </v-list>
              </v-menu> -->
            </div>

            <div class="card-meta">
              <div class="author">{{firstname}} {{lastname}}</div>
              <div class="document-wrap">
                <div class="document">{{ $t("lab.document") }} {{ item.num_docs }}</div>
              </div>
            </div>
            <div class="card-date">
              <div class="card-date-row">
                <span class="row-title">{{ $t('lab.start') }}</span>
                <span>{{ item.created_ts.substr(0, 10) }}</span>
              </div>
              <div class="card-date-row"
                v-if="!!item.note_modified_ts&&!!item.note_wc&&item.status!=2">
                <span class="row-title">{{ $t("lab.modified") }}</span>
                <span>{{ item.note_modified_ts.substr(0,10) }}</span>
              </div>
              <div class="card-date-row"
                v-if="item.status==2&&!!item.completed_ts">
                <span class="row-title">{{ $t('lab.close') }}</span>
                <span>{{ item.completed_ts.substr(0, 10) }}</span>
              </div>
            </div>
          </v-card>
          <div v-for="i in ph_numbers"
            :key="i" 
            class="card-placeholder">
          </div>
        </div>

      </div>

      <!-- Inactivated projects -->
      <div class="list-projects"
        v-if="!!inactivated_projects.length">

        <div class="list-header">
          <div class="list-title">
            <span>{{ $t('lab.read_only_project') }}</span>
            <span>[{{ inactivated_projects.length }}]</span>
          </div>
        </div>

        <div class="list-cards">
          <v-card class="card inactive-card" flat
            v-for="(item, index) in inactivated_projects"
            :key="`card-${index}-${item.list_mode}`"
            @click="getProject(item.proj_id)">

            <div class="card-header">
              <div class="card-title">
                <span v-if="item.mode==11"><v-icon>mdi-account-multiple</v-icon>&nbsp;</span>
                <span>{{ item.title }}</span>
              </div>
            </div>

            <div class="card-meta">
              <div class="author">{{firstname}} {{lastname}}</div>
              <div class="document-wrap">
                <div class="document">{{ $t("lab.document") }} {{ item.num_docs }}</div>
              </div>
            </div>
            <div class="card-date">
              <div class="card-date-row">
                <span class="row-title">{{ $t('lab.start') }}</span>
                <span>{{ item.created_ts.substr(0, 10) }}</span>
              </div>
              <div class="card-date-row"
                v-if="!!item.note_modified_ts&&!!item.note_wc&&item.status!=2">
                <span class="row-title">{{ $t("lab.modified") }}</span>
                <span>{{ item.note_modified_ts.substr(0,10) }}</span>
              </div>
              <div class="card-date-row"
                v-if="item.status==2&&!!item.completed_ts">
                <span class="row-title">{{ $t('lab.close') }}</span>
                <span>{{ item.completed_ts.substr(0, 10) }}</span>
              </div>
            </div>
          </v-card>
          <div v-for="i in ph_numbers"
            :key="i" 
            class="card-placeholder">
          </div>
        </div>

      </div>
    </div>

    <!-- Modals -->

    <modal-create-project
      :dialog.sync="create_project_visible">
    </modal-create-project>

    <modal-update-project
      :dialog.sync="update_project_visible">
    </modal-update-project>

    <!-- No more dialog -->
    <template>
      <v-dialog v-model="no_more_dialog" width="400px">
        <v-card>
          <v-card-title class="card-title-wrapper">
            <span>BT 프리미엄 회원이 되어주세요!</span>
            <v-btn icon @click="no_more_dialog=false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            <div class="word-break">일반 회원은 3개의 프로젝트를 사용하실 수 있습니다.</div>
            <div class="word-break">프리미엄을 구독하시면 더 많은 프로젝트를 만들 수 있습니다.</div>
          </v-card-text>

          <v-card-actions>
            <v-btn class="primary" @click="toSignup" depressed block>
              프리미엄 구독하기
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <!-- Activate dialog -->
    <template>
      <v-dialog v-model="activate_dialog" width="400px" scrollable
        @keydown.esc="close()">
        <v-card>
          <v-card-title class="card-title-wrapper">
            <span>활성화할 프로젝트를 선택해주세요</span>
            <v-btn icon @click="activate_dialog=false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            <div class="word-break">일반 회원은 3개의 프로젝트를 사용하실 수 있습니다.</div>
            <div class="word-break meta-text">
              <v-icon small color="primary">mdi-information-outline</v-icon>
              활성화된 프로젝트를 다시 읽기 전용으로 바꿀 수는 없습니다.</div>
            <div class="word-break meta-text">
              <v-icon small color="primary">mdi-information-outline</v-icon>
              읽기 전용은 도큐먼트 추가제거, 프로젝트 노트 편집이 불가합니다.</div>
          </v-card-text>
          <v-card-text>
            <v-checkbox v-for="proj in inactivated_projects"
              :disabled="num_activate_possible==selected_ids.length&&!selected_ids.includes(proj.proj_id)"
              :key="proj.proj_id"
              v-model="selected_ids"
              :label="proj.title"
              :value="proj.proj_id"
            ></v-checkbox>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" dark depressed block 
              @click="activateProject()">
              프로젝트 활성화하기
            </v-btn>
          </v-card-actions>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div>모든 프로젝트를 활성화하시려면?</div>
            <v-btn small text color="#ff5193"
              @click="toSignup">프리미엄 구독하기</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

  </div>
</template>

<script>
import VClamp from 'vue-clamp'
import { mapGetters, mapMutations } from 'vuex'
import { project_status } from '../../../custom/model'
import { sortProjects } from '../../../custom/function.js'

export default {
  metaInfo() {
    return {
      title: "Projects",
    }
  },

  components: {
    VClamp,
  },

  props: {
    ph: {
      required: true,
      type: Number,
    },
  },

  data() {
    return {
      busy: false,
      project_status: project_status,
      create_project_visible: false,
      update_project_visible: false,

      sort_by: 0,
      sorted_projects: [],

      no_more_dialog: false,
      activate_dialog: false,
      activated_projects: [],
      selected_ids: [],
      inactivated_projects: [],
    }
  },

  computed: {
    ...mapGetters({
      projects: 'project/projects',
      firstname: 'user/firstname',
      lastname: 'user/lastname',
      is_expired: 'auth/is_expired',
    }),

    ph_numbers() {
      return !this.ph ? [] : [...Array(this.ph).keys()]
    },

    is_inactive() {
      return !!this.inactivated_projects.length && this.activated_projects.length < 3
    },

    num_activate_possible() {
      return 3 - this.activated_projects.length
    },
  },

  watch: {
    projects: {
      handler(val) {
        this.getProjects()
      },
      immediate: true,
      deep: false,
    },

    sort_by(val) {
      this.sorted_projects = this.sortProjects(this.sorted_projects, this.sort_by) || []
    },
  },

  methods: {
    sortProjects,

    createProject() {
      if (this.is_expired && this.activated_projects.length >= 3) {
        this.no_more_dialog = true
      } else {
        this.$analytics.logEvent('click', { name: 'lab_btn_createProject' })
        this.create_project_visible = true
      }
    },

    getProjects() {
      let projs = JSON.parse(JSON.stringify(this.projects))
      projs = projs.filter(v => v.mode != 9)
      this.sorted_projects = this.sortProjects(projs, this.sort_by) || []

      this.activated_projects = this.sorted_projects.filter(v => v.status < 10)
      this.inactivated_projects = this.sorted_projects.filter(v => v.status >= 10)

      if (this.is_expired && this.activated_projects.length > 3) {
        this.activated_projects.forEach(v => this.updateStatus(v.proj_id, v.status + 10))
      } else if (!this.is_expired && !!this.inactivated_projects.length) {
        this.inactivated_projects.forEach(v => this.updateStatus(v.proj_id, v.status - 10))
      }
    },

    getProject(proj_id) {
      this.$router.push({name: 'project', params: {id: proj_id}})
    },

    async updateStatus(proj_id, status) {
      await this.$store.dispatch('project/updateStatus', {
        proj_id, status
      })
    },

    toSignup() {
      this.no_more_dialog = false
      this.$router.push({ name: 'signup' })
    },

    activateProject() {
      if (!!this.selected_ids.length) {
        for (let i=0; i<this.selected_ids.length; i++) {
          let selected_id = this.selected_ids[i]
          let status = this.inactivated_projects.filter(v => v.proj_id == selected_id)[0].status
          this.updateStatus(selected_id, status - 10)
        }
        this.activate_dialog = false
        this.selected_ids = []
      }
    },
  },

}
</script>

<style scoped>
  #wrap-projects {
    width: 100%;
    height: 100%;
  }

  /* Header */

  #header-projects {
    padding: 20px 40px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  #title-projects {
    font-size: 16px;
    font-weight: 600;
    color: #323334;
  }

  #btns-projects {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  #create-project {
    margin-right: 8px;
  }

  /* Content */

  #container-projects {
    padding: 20px 40px;
  }

  .list-projects {
    border-top: solid 1px #dde2e5;
    padding-bottom: 24px;
  }

  .list-projects:first-child {
    border-top: none;
  }

  .list-header {
    padding-top: 16px;
    width: 100%;
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 20px;
    color: rgb(95, 99, 104);
    font-size: 14px;
  }

  .list-cards {
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    align-content: stretch;
  }

  .card {
    padding: 20px 12px 20px 20px;
    border-radius: 4px;
    border: solid 1px #dde2e5 !important;
    background-color: #ffffff;
    margin: 10px;
    flex-basis: 252px;
    flex-grow: 1;
  }

  .inactive-card {
    background-color: #dde2e5 !important;
  }

  .card:hover {
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);
  }

  .card .more {
    visibility: hidden;
  }

  .card:hover .more {
    visibility: visible;
  }

  .card-placeholder {
    flex-basis: 252px;
    flex-grow: 1;
    margin: 10px;
  }

  .card-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .card-title {
    font-size: 14px;
    font-weight: 600;
    color: #323334;
  }

  .card-meta {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .author {
    margin-right: 5px;
  }

  .document-wrap {
    margin-left: 4px;
    padding: 4px 10px 3px 11px;
    border-radius: 12px;
    background-color: rgba(83, 107, 255, 0.1);
  }

  .document {
    font-size: 11px;
    font-weight: 500;
    color: #455ffe;
    width: 100%;
  }

  .card-date {
    margin-top: 4px;
  }

  .card-date-row {
    color: #858d97;
  }

  /* Empty */

  #empty-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 60px);
    width: 100%;
  }

  #empty-title {
    display: flex;
    flex-direction: row;
    justify-content: center;
    font-size: 20px;
    font-weight: 600;
  }

  #empty-title i {
    margin-left: 3px;
  }

  #empty-subtitle {
    font-size: 14px;
  }

  #empty-create-project {
    margin-top: 12px;
  }

  .premium-func {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
  }

  .premium-func i {
    margin-right: 12px;
  }

  .card-title-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }

  .meta-text {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.54);
  }

</style>


// WEBPACK FOOTER //
// src/components/spa/lab/Projects.vue